import { VscHome, VscPreview } from "react-icons/vsc";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { FiCalendar } from "react-icons/fi";
import { IoMdBook } from "react-icons/io";
import { IoMdSchool, IoMdNotifications } from "react-icons/io";
import { MdEdit } from "react-icons/md";
// import { MdPayment } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import { FaChalkboardTeacher, FaRegHeart } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineRequestPage } from "react-icons/md";
import { BiEnvelope } from "react-icons/bi";
import { IoWalletOutline } from "react-icons/io5";
import { BiPurchaseTagAlt } from "react-icons/bi";
import { FaRegStar } from "react-icons/fa";

export const teacherRouteConfig = [
  {
    path: "/teacher",
    icon: VscHome,
    name: "Home",
  },
  {
    path: "/teacher/offers",
    icon: MdOutlineRequestPage,
    name: "Offers",
  },
  {
    path: "/teacher/messages",
    icon: BiEnvelope,
    name: "Messages",
  },
  {
    // path: "/teacher/courses",
    icon: IoMdBook,
    name: "My Profile",
    children: [
      {
        path: "/teacher/profile-preview",
        icon: VscPreview,
        name: "Preview",
      },
      {
        path: "/teacher/settings",
        icon: FiSettings,
        name: "Personal Info",
      },
      {
        path: "/teacher/courses",
        icon: IoMdBook,
        name: "Preferences",
      },
      {
        path: "/teacher/teaching-boards",
        icon: IoMdBook,
        name: "Teaching Boards",
      },
      // {
      //   path: "/teacher/teaching-board",
      //   icon: MdOutlineCastForEducation,
      //   name: "Teaching Boards",
      // },

      {
        path: "/teacher/education",
        icon: IoMdSchool,
        name: "Education",
      },
      {
        path: "/teacher/documents",
        icon: IoDocumentTextOutline,
        name: "Documents",
      },
      {
        path: "/teacher/experience",
        icon: FaHandHoldingDollar,
        name: "Experience",
      },
      {
        path: "/teacher/modeOfTeaching",
        icon: MdEdit,
        name: "Mode",
      },
      {
        path: "/teacher/slot",
        icon: FiCalendar,
        name: "Slot",
      },
    ],
  },
  // {
  //   path: "/teacher/schedule",
  //   icon: MdSchedule,
  //   name: "Schedule Meeting",
  // },

  // {
  //   path: "/teacher/payment",
  //   icon: MdPayment,
  //   name: "Payment",
  // },
  {
    path: "/teacher/wallet-summary",
    icon: IoWalletOutline,
    name: "Wallet",
  },
  {
    path: "/teacher/subscription",
    icon: BiPurchaseTagAlt,
    name: "Subscription",
  },
  {
    path: "/teacher/notifications",
    icon: IoMdNotifications,
    name: "Notifications",
  },
];

export const studentRouteConfig = [
  {
    path: "/student",
    icon: VscHome,
    name: "Home",
  },
  // {
  //   path: "/student/dashboard",
  //   icon: VscHome,
  //   name: "Dashboard",
  // },
  {
    path: "/student/offers",
    icon: MdOutlineRequestPage,
    name: "Offers",
  },
  {
    path: "/student/messages",
    icon: BiEnvelope,
    name: "Messages",
  },

  // {
  //   path: "/student/about",
  //   icon: BiEnvelope,
  //   name: "Messages",
  // },

  {
    path: "/search",
    icon: FaChalkboardTeacher,
    name: "Find Teacher",
  },
  {
    path: "/student/favourite-teachers",
    icon: FaRegHeart,
    name: "Favourites",
  },
  {
    path: "/student/wallet-summary",
    icon: IoWalletOutline,
    name: "Wallet",
  },
  {
    path: "/student/session-reviews",
    icon: FaRegStar,
    name: "Session Reviews",
  },

  {
    path: "/student/settings",
    icon: FiSettings,
    name: "My Profile",
  },
  {
    path: "/student/notifications",
    icon: IoMdNotifications,
    name: "Notifications",
  },
];
